import { WarehouseDto } from "@insite/client-framework/Types/ApiModels";
import getBooleanProperty from "@store/utilities/getBooleanProperty";
import { useEffect, useMemo, useState } from "react";

// Hook to compute excluded warehouses
export const useExcludedWarehouses = (availabilityOnlyWarehouses?: string) => {
    const [sortedOutWarehousesList, setSortedOutWarehousesList] = useState<string>("");

    useEffect(() => {
        const availabilityArray = availabilityOnlyWarehouses ? availabilityOnlyWarehouses.split(",") : [];
        setSortedOutWarehousesList(availabilityArray.join(","));
    }, [availabilityOnlyWarehouses]);

    return useMemo(() => sortedOutWarehousesList?.split(",") ?? [], [sortedOutWarehousesList]);
};

// Generic function to filter warehouses
export const filterWarehouses = <T extends { name: string }>(
    arr: T[] | null | undefined,
    excludedWarehouses: string[],
    warehouseType: "dto" | "model"
): T[] => {
    if (!arr) {return [];}

    const isDto = warehouseType === "dto";

    return arr.filter(x => {
        if (excludedWarehouses.includes(x.name)) {return false;}

        return isDto
            ? getBooleanProperty((x as any).properties?.isAllowPickup) && (x as any).properties?.address1
            : (x as any).allowPickup && (x as any).address1;
    });
};


